/**
 * TODO: удалить
 * @returns
 */

export const usePhotolineEnabled = () => {
  return false
}
